import 'core-js/stable'
import Vue from 'vue'
import CoreuiVue from '@coreui/vue'
import App from './App'
import router from './router/index'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import { formatNumber } from './utils/format'

import VueAxios from 'vue-axios'
import axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import '@fortawesome/fontawesome-free/css/all.css'

const currentOrigin = window.location.origin;

const backendBaseURL = currentOrigin.includes(':')
  ? currentOrigin.replace(/:\d+$/, ':8000') // Replace existing port
  : `${currentOrigin}:8000`; // Add port if not present


const $appRequest = axios.create({
  baseURL: backendBaseURL,
  timeout: 60000,  // Request timeout
});

let busyDelayTimer = null
// Add a request interceptor
$appRequest.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    const username = localStorage.getItem('username');
    const role = localStorage.getItem('role');
    if (token) {
      config.headers.Authorization = `${token}`;
      config.headers.Username = username;
      config.headers.role = role;
    }
    // const fullUrl = config.baseURL + config.url;
    // console.log('Request URL:', fullUrl);
    if (config.method && (config.method.toLowerCase() === 'post' ||
      config.method.toLowerCase() === 'delete' ||
      config.method.toLowerCase() === 'put')) {
      store.state.notiPending = true;
      //console.log('set notiPending', store.state.notiPending);
    }

    if (config.method && ['post', 'put', 'delete'].includes(config.method.toLowerCase())) {
      const url = config?.url || ''
      const skipBusyUrls = [
        '/api/actions-recent',
        '/login',
      ]
      if (!skipBusyUrls.some(u => url.includes(u))) {
        if (busyDelayTimer) clearTimeout(busyDelayTimer)
        busyDelayTimer = setTimeout(() => {
          Vue.prototype.$showBusy('Đang xử lý...')
        }, 300)
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

$appRequest.interceptors.response.use(
  (response) => {
    const url = response.config?.url || ''
    const method = response.config?.method?.toUpperCase() || 'get'
    const skipBusyUrls = [
      '/api/actions-recent',
    ]
    if (busyDelayTimer) {
      clearTimeout(busyDelayTimer)
      busyDelayTimer = null
    }
    if (!skipBusyUrls.some(u => url.includes(u))) {
      if (method && ['post', 'put', 'delete'].includes(method.toLowerCase())) {
        Vue.prototype.$closeBusy()
      }
    }

    const newAccessToken = response.headers['authorization'];
    if(newAccessToken) {
      localStorage.setItem('token', newAccessToken);
      $appRequest.interceptors.request.use((config) => {
        config.headers.Authorization = `${newAccessToken}`;
        return config;
      });
    }
    return response;
  },
  (error) => {
    if (busyDelayTimer) {
      clearTimeout(busyDelayTimer)
      busyDelayTimer = null
    }
    Vue.prototype.$closeBusy();
    if (error.response &&
      error.response.status === 401) {
      Vue.prototype.$logout();
    }
    // Optionally handle other errors like 403, 500, etc.
    if (error.response &&
      (error.response.status === 403 ||
        error.response.status === 404 ||
        error.response.status === 502)) {
      Vue.prototype.$logout();
    }
    return Promise.reject(error);
  }
);

Vue.prototype.$logout = function () {
  localStorage.removeItem('token');
  localStorage.removeItem('username');
  localStorage.removeItem('role');
  if (router.currentRoute.path !== '/login') {
    router.push('/login');
  }
}

const options = {
  confirmButtonText: 'Xác nhận',
  cancelButtonText: 'Hủy bỏ',
}

Vue.use(CoreuiVue)
Vue.use(VueAxios, {$request: $appRequest})
Vue.use(VueSweetalert2, options);

Vue.prototype._busyTimer = null

Vue.prototype.$showBusy = function (message = 'Đang xử lý...', timeoutMs = 30000) {
  this.$swal.fire({
    title: message,
    html: 'Vui lòng chờ...',
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      this.$swal.showLoading()
    },
  })

  if (timeoutMs > 0) {
    if (this._busyTimer) clearTimeout(this._busyTimer)
    this._busyTimer = setTimeout(() => {
      this.$swal.close()
      this.$swal.fire({
        icon: 'warning',
        title: 'Quá thời gian chờ',
        text: 'Máy chủ phản hồi quá lâu. Vui lòng thử lại sau.',
      })
    }, timeoutMs)
  }
}

Vue.prototype.$closeBusy = function () {
  if (this._busyTimer) {
    clearTimeout(this._busyTimer)
    this._busyTimer = null
  }
  this.$swal.close()
}

// Global formatNumber method for all Vue components
Vue.prototype.formatNumber = formatNumber


new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
